import { render } from "./PriceInput2.vue?vue&type=template&id=018662d1"
import script from "./PriceInput2.vue?vue&type=script&lang=js"
export * from "./PriceInput2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__